import { memo } from 'react';
import { UseFullScreen } from '../context/FullScreen.context';
import Mediapipe from './Mediapipe';

function Capture() {
	const { isFullScreen } = UseFullScreen();

	return (
		<div
			style={{
				maxWidth: isFullScreen ? '100%' : 1280,
				width: '100%',
				aspectRatio: '16/9',
				display: 'block',
				zIndex: 2,
				height: isFullScreen ? '100%' : 720,
				position: 'relative',
			}}>
			<Mediapipe />

			{/* <div
				style={{
					position: 'absolute',
					top: 0,
					right: 0,
					background: 'rgba(0,0,0,0.5)',
					color: 'white',
					padding: '10px',
					borderRadius: '5px',
					zIndex: 20,
					display: 'flex',
					flexDirection: 'column',
					gap: '5px',
				}}>
				<p
					style={{ fontSize: '32px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
					Facing: {personOrientation && personOrientation}
				</p>
				<p
					style={{ fontSize: '32px', fontWeight: 'bold', margin: '0 0 5px 0' }}>
					Transition: {transition && JSON.stringify(transition?.value)}
				</p>
			</div> */}
		</div>
	);
}

export default memo(Capture);
